/**
 * Pure helpers + small presentational components shared by NewTicketDialog.
 * Extracted from the dialog to keep the host component focused on
 * form/state orchestration.
 */
import React from "react";
import { AlertCircle } from "lucide-react";

export const PRIORITY_LABEL = {
  low: "Low",
  medium: "Medium",
  high: "High",
  critical: "Critical",
};

export const fmtSla = (m) => {
  if (!m) return "";
  if (m < 60) return `${m} min`;
  if (m % 60 === 0) return `${m / 60} hour${m / 60 !== 1 ? "s" : ""}`;
  return `${m} min`;
};

export const AUTO_INPUT_CLS = "bg-slate-50 border-slate-200 text-slate-600 cursor-not-allowed";

export const Req = () => <span className="text-rose-500 ml-0.5">*</span>;

// Inline field-level validation message + a helper for the red invalid border.
export const FieldError = ({ name, msg }) =>
  msg ? (
    <p
      className="text-[11px] text-rose-600 mt-1 flex items-center gap-1"
      data-testid={`error-${name}`}
    >
      <AlertCircle className="w-3 h-3 shrink-0" strokeWidth={2.4} />
      {msg}
    </p>
  ) : null;

export const invalidCls = (msg) =>
  msg ? "border-rose-400 focus-visible:ring-rose-400" : "";

export const SectionHeader = ({ letter, title, subtitle, icon: Icon }) => (
  <div className="flex items-center gap-2 mb-4 pb-2.5 border-b border-slate-200">
    {Icon && <Icon className="w-4 h-4 text-indigo-600" strokeWidth={2} />}
    <span className="font-heading text-xs font-bold text-indigo-600 uppercase tracking-[0.18em]">
      {letter}
    </span>
    <h3 className="font-heading text-sm font-semibold text-slate-900 uppercase tracking-wider">
      {title}
    </h3>
    {subtitle && (
      <span className="text-[10px] uppercase tracking-wider text-slate-400 font-medium ml-2">
        {subtitle}
      </span>
    )}
  </div>
);
